var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 331.3 336",
    style: {
      enableBackground: "new 0 0 331.3 336"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#595757;}\n\t.st1{fill:#2C6CFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.2,336H72c-39.6,0-72-32.4-72-72v-2.4l7.2-192C8.4,30,40.8,0,79.2,0H252c38.4,0,70.8,30,72,69.6l7.2,192 c1.2,19.2-6,37.2-19.2,51.6c-13.2,14.4-31.2,22.8-50.4,22.8C261.6,336,260.4,336,259.2,336L259.2,336z M79.2,24 c-26.4,0-46.8,20.4-48,45.6L24,264c0,26.4,21.6,48,48,48h189.6c13.2,0,25.2-6,33.6-15.6c8.4-9.6,13.2-21.6,13.2-34.8l-7.2-192 C300,43.2,279.6,24,253.2,24H79.2z M79.2,24"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.6,144c-46.8,0-84-37.2-84-84c0-7.2,4.8-12,12-12c7.2,0,12,4.8,12,12c0,33.6,26.4,60,60,60s60-26.4,60-60 c0-7.2,4.8-12,12-12s12,4.8,12,12C249.6,106.8,212.4,144,165.6,144L165.6,144z M165.6,144"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/전제상품.d957ad701c5757b467a827cf632b8dc8.svg";
export { ForwardRef as ReactComponent };